export enum ImageRepositoryLabel {
  APPLICATION = 'appstudio.redhat.com/application',
  COMPONENT = 'appstudio.redhat.com/component',
}
